import { AppBar, Badge, Button, Grid2, IconButton, MenuItem, Modal, Paper, Select, Snackbar, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Typography } from "@mui/material";
import { use, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TokenError from "../tokenError";
import { Box, Grid, styled } from "@mui/system";
import PropTypes from 'prop-types';
import config from '../../config/config.js';
import { makeGetRequestToUrl } from "../commonFunc.jsx";
import { makePostRequestToUrl } from "../commonFunc.jsx";
import CloseIcon from '@mui/icons-material/Close';
import { Label } from "flowbite-react";
import InfoIcon from '@mui/icons-material/Info';
import binIcon from '../../assets/icons/redBin.svg';
import blackEdit from '../../assets/icons/blackEdit.svg';
import axios from "axios";

function a11yProps(index){
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
      };
}

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '16px',
    marginRight: theme.spacing(1),
    width:'15%',
    marginTop:'4px',
    marginBottom:'4px',
    color: '#83888E',
    '&.Mui-selected': {
      color: '#fff',
      borderRadius: '4px 4px 0 0',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
}));

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
}
  
CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
const TabWithBadge = ({ label, count, isActive }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography sx={{ color: isActive ? '#fff' : '#83888E', marginRight:'12px' }}>{label}</Typography>
      <Badge
        badgeContent={count}
        sx={{
          '& .MuiBadge-badge': {
            backgroundColor: '#4B4F58',
            color: '#fff',
            borderRadius: '50%',
            minWidth: '22px',
            height: '22px',
            fontSize: '12px',
            fontWeight: 500,
          },
        }}
      />
    </Box>
);

const ShuttlePass = () => {
    const [tokenExpired, setTokenExpired] = useState(false);
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [snackbar, showSnackbar] = useState(false);
    const [message, setMessage] = useState('');
    const [shuttlePassTab, setShuttlePassTab] = useState(0);
    const [shuttlePassData, setShuttlePassData] = useState([]);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const [openAddModal, setOpenAddModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [passId, setPassId] = useState('');
    const [passName, setPassName] = useState('');
    const [passType, setPassType] = useState('');
    const [totalRides, setTotalRides] = useState('');
    const [morningRides, setMorningRides] = useState('');
    const [eveningRides, setEveningRides] = useState('');
    const [totalFareDiscount, setTotalFareDiscount] = useState('');
    const [validity, setValidity] = useState('');
    const [status, setStatus] = useState(false);
    const [isRecommended, setIsRecommended] = useState(false);
    const [benefits, setBenefits] = useState(['']);
    const [shuttlePassMetaData, setShuttlePassMetaData] = useState([]);
    const [openAddMetaDataModal, setAddOpenMetaDataModal] = useState(false);
    const [editMetaDataMode, setEditMetaDataMode] = useState(false);
    const [metaDataId, setMetaDataId] = useState('');
    const [metaDataTitle, setMetaDataTitle] = useState('');
    const [metaDataDescription, setMetaDataDescription] = useState('');
    const [metaDataIcon, setMetaDataIcon] = useState('');
    const [metaDataStatus, setMetaDataStatus] = useState(true);
    const [recommendedPassId, setRecommendedPassId] = useState(0);
    const [recommendedPasses, setRecommendedPasses] = useState([]);
    const [showStatusConfirmModal, setShowStatusConfirmModal] = useState(false);
    const [pendingStatusChange, setPendingStatusChange] = useState(null);

    const [passLimit, setPassLimit] = useState('');
    const [perUserPassLimit, setPerUserPassLimit] = useState('');
    const [perUserCancelLimit, setPerUserCancelLimit] = useState('');

    // Add this effect to sync isRecommended state
    useEffect(() => {
        const isPassRecommended = recommendedPasses.some(pass => pass.pass_id === passId);
        setIsRecommended(isPassRecommended);
    }, [recommendedPasses, passId]);

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const handleSnackbarClose = () => {
        showSnackbar(false);
    }

    const handleAllyProps = (event, newValue) => {
        setShuttlePassTab(newValue);
        setCityFilter(cities[0].city_id);
    };

    const fetchShuttlPassData = async() => {
        let recommendedPassesList = [];
        try {
            const url = serverUrl + '/shuttle/fetch_pass';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag === 200) {
                setShuttlePassData(response.data);
                response.data.forEach(element => {
                    if(element.is_recommended === 1 && element.status === 1) {
                        recommendedPassesList.push({
                            pass_id: element.pass_id,
                            pass_type: element.pass_type
                        });
                    }
                });
                setRecommendedPasses(recommendedPassesList);
                // Keep the existing recommendedPassId for backward compatibility if needed
                if (recommendedPassesList.length > 0) {
                    setRecommendedPassId(recommendedPassesList[0].pass_id);
                }
            }
            // ... rest of the function
        } catch (error) {
            console.error('Error fetching pass data:', error);
        }
    };

    const fetchShuttlPassMetaData = async() => {
        try {
            const url = serverUrl + '/shuttle/fetch_pass_meta_data';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                meta_data_type: shuttlePassTab,
                timestamp: timestamp
            };
            const response = await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                console.log('response.data', response.data);
                setShuttlePassMetaData(response.data);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        if(shuttlePassTab == 0) fetchShuttlPassData();
        else fetchShuttlPassMetaData();
    },[shuttlePassTab,cityFilter])

    const handleOpenAddModal = () => {
        setOpenAddModal(true);
        setEditMode(false);
        setPassId('');
        setPassName('');
        setPassType('');
        setTotalRides('');
        setTotalFareDiscount('');
        setValidity('');
        setStatus(true);
        setIsRecommended(false);
        setMorningRides('');
        setEveningRides('');
        setBenefits(['']);
        setPassLimit('');
        setPerUserPassLimit('');
        setPerUserCancelLimit('');
    }

    const handleClose = () => {
        setOpenAddModal(false);
        setEditMode(false);
    }

    const handleAddBenefit = () => {
        setBenefits([...benefits, '']);
    };

    const handleBenefitChange = (index, value) => {
        const newBenefits = [...benefits];
        newBenefits[index] = value;
        setBenefits(newBenefits);
    };

    const handleRemoveBenefit = (index) => {
        if (benefits.length > 1) {
            const newBenefits = benefits.filter((_, i) => i !== index);
            setBenefits(newBenefits);
        }
    };

    const handleShuttlePassSubmit = async() => {
        if(passName == ''){
            setMessage('Please enter Pass Name');
            showSnackbar(true);
            return;
        }
        if(passType == ''){
            setMessage('Please select Pass Type');
            showSnackbar(true);
            return;
        }
        if(totalFareDiscount == ''){
            setMessage('Please enter Fare Discount');
            showSnackbar(true);
            return;
        }
        if(passType == 1 && totalRides == ''){
            setMessage('Please enter Total Rides');
            showSnackbar(true);
            return;
        }
        if(passType == 2 && morningRides == ''){
            setMessage('Please enter the number of morning rides');
            showSnackbar(true);
            return;
        }
        
        // Check if at least one benefit is added
        if (benefits.length === 0 || benefits.every(benefit => !benefit.trim())) {
            setMessage('Please add at least one benefit');
            showSnackbar(true);
            return;
        }
        
        // Check recommended pass validation
        if (isRecommended) {
            // Check if there's already a recommended pass of the same type
            const existingOfSameType = recommendedPasses.find(
                pass => pass.pass_type == passType && pass.pass_id != passId
            );
            
            if (existingOfSameType) {
                setMessage(
                    `A ${passType === 1 ? 'One Way' : 'Return'} pass is already recommended. ` +
                    'Only one pass per type can be recommended.'
                );
                showSnackbar(true);
                return;
            }
        }
        
        const payload = {
            token: token,
            city_id: cityFilter, 
            pass_name: passName,
            pass_type: passType,
            discount_percentage: totalFareDiscount,
            validity_days: passType==1 ? totalRides : Number(morningRides),
            benefits: benefits,
            is_recommended: isRecommended ? 1: 0,
            status: status ? 1: 0,
            total_rides: passType==1 ? totalRides : Number(morningRides*2),
            morning_rides: passType==1 ? 0 : morningRides,
            evening_rides: passType==1 ? 0 : morningRides,
            total_pass_limit: passLimit ? passLimit : 0,
            per_user_pass_limit: perUserPassLimit ? perUserPassLimit : 0,
            per_user_cancellation_limit: perUserCancelLimit ? perUserCancelLimit : 0
        };
        console.log('passLimit= ', passLimit);
        console.log('perUserPassLimit= ', perUserPassLimit);
        console.log('perUserCancelLimit= ', perUserCancelLimit);
        // if(passLimit || passLimit==0){
        //     payload.total_pass_limit = passLimit;
        // }
        // if(perUserPassLimit || perUserPassLimit==0){
        //     payload.per_user_pass_limit = perUserPassLimit;
        // }
        // if(perUserCancelLimit || perUserCancelLimit==0){
        //     payload.per_user_cancellation_limit = perUserCancelLimit;
        // }

        if(passId!=''){
            payload.pass_id = passId;
        }
        console.log('payload= ', payload);
        try {
            const url = operationsUrl + '/shuttle/add_update_shuttle_pass';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setOpenAddModal(false);
                setEditMode(false);
                setMessage(response.message)
                showSnackbar(true);
                fetchShuttlPassData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error', error);
            setMessage(error);
        }
    }

    const handleOpenEditShuttlePass = (row) => {
        setOpenAddModal(true);
        setEditMode(true);
        setPassId(row.pass_id);
        setPassName(row.pass_name);
        setPassType(row.pass_type);
        setTotalRides(row.total_rides);
        setTotalFareDiscount(row.discount_percentage);
        setValidity(row.validity_days);
        setStatus(row.status);
        setIsRecommended(row.is_recommended);
        setMorningRides(row.morning_rides);
        setEveningRides(row.evening_rides);
        setBenefits(row.benefits);
        setPassLimit(row.total_pass_limit);
        setPerUserPassLimit(row.per_user_pass_limit);
        setPerUserCancelLimit(row.per_user_cancellation_limit);
    }

    const handleOpenAddMetaDataModal = () => {
        setMetaDataId('');
        setMetaDataTitle('');
        setMetaDataDescription('');
        setMetaDataIcon('');
        setMetaDataStatus(true);
        setAddOpenMetaDataModal(true);
        setEditMetaDataMode(false);
    }

    const handleOpenEditMetaDataModal = (row) => {
        setMetaDataId(row.id);
        setMetaDataTitle(row.title);
        setMetaDataDescription(row.description);
        setMetaDataIcon(row.icon_url);
        setMetaDataStatus(row.status === 1);
        setAddOpenMetaDataModal(true);
        setEditMetaDataMode(true);
    }

    const handleCloseMetaDataModal = () => {
        setAddOpenMetaDataModal(false);
        setEditMetaDataMode(false);
    }

    const getMetaTitle = () => {
        if (shuttlePassTab === 1) {
            return editMetaDataMode ? 'Edit Benefit' : 'Add Benefit';
        }
        else if (shuttlePassTab === 2) {
            return editMetaDataMode ? 'Edit Step' : 'Add Step';
        }
        else if (shuttlePassTab === 3) {
            return editMetaDataMode ? 'Edit FAQ' : 'Add FAQ';
        }
        else if (shuttlePassTab === 4) {
            return editMetaDataMode ? 'Edit Privacy Policy' : 'Add Privacy Policy';
        }
    };

    const handleShuttlePassMetaDataSubmit = async () => {
        if(metaDataTitle==''){
            if(shuttlePassTab == 3){
                setMessage('Question is required.');
                showSnackbar(true);
                return;
            }
            else{
                setMessage('Title is required.');
                showSnackbar(true);
                return;
            }
        }
        if(metaDataDescription==''){
            if(shuttlePassTab == 3){
                setMessage('Answer is required.');
                showSnackbar(true);
                return;
            }
            else{
                setMessage('Description is required.');
                showSnackbar(true);
                return;
            }
        }
        if(shuttlePassTab == 1 && shuttlePassTab == 2){
            if(metaDataIcon == ''){
                setMessage('Icon is required');
                showSnackbar(true);
                return;
            }
        }
        const payload = {
            token: token,
            city_id: cityFilter, 
            title: metaDataTitle,
            description: metaDataDescription,
            type: shuttlePassTab,
            status: metaDataStatus ? 1 : 0
        };
        if(metaDataId!=''){
            payload.id = metaDataId;
        }
        if(metaDataIcon != '' && metaDataIcon!=null){
            payload.icon_url = metaDataIcon;
        }
        try {
            const url = operationsUrl + '/shuttle/add_update_shuttle_pass_metadata';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setAddOpenMetaDataModal(false);
                setEditMetaDataMode(false);
                setMessage(response.message)
                showSnackbar(true);
                fetchShuttlPassMetaData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error', error);
            setMessage(error);
        }
    }

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);
        try {
            await new Promise((resolve, reject) => {
                img.onload = () => resolve();
                img.onerror = reject;
                img.src = objectUrl;
            });
            const validW = img.width == 64;
            const validH = img.height == 64;
            if (!validW || !validH) {
                setMessage('Please upload an icon with the given size.');
                showSnackbar(true);
                event.target.value = '';
                return;
            }
        } finally {
            URL.revokeObjectURL(objectUrl);
        }
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await axios.post(operationsUrl + '/upload_image', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            const s3Url = response.data.url;
            setMetaDataIcon(s3Url);
        } catch (error) {
            console.error('Error uploading image:', error);
        }
    };

    const handleDeleteMetaData = async(data) => {
        const payload = {
            token: token,
            city_id: cityFilter, 
            status: -1,
            id: data.id
        };
        try {
            const url = operationsUrl + '/shuttle/add_update_shuttle_pass_metadata';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchShuttlPassMetaData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            setMessage(error);
        }
    }
    const handleDeleteShuttlePassData = async(data) => {
        const payload = {
            token: token,
            city_id: cityFilter, 
            status: -1,
            pass_id: data.pass_id
        };
        try {
            const url = operationsUrl + '/shuttle/add_update_shuttle_pass';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchShuttlPassData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            setMessage(error);
        }
    }

    const changeStatusMetaData = async(data, status) => {
        const payload = {
            token: token,
            city_id: cityFilter, 
            status: status ==1 ? 1: 0,
            id: data.id
        };
        try {
            const url = operationsUrl + '/shuttle/add_update_shuttle_pass_metadata';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchShuttlPassMetaData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            setMessage(error);
        }
    }

    return(
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Shuttle Pass
            </Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'2%'}}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item sx={{marginLeft:'auto'}}>
                    <Button
                        variant="contained"
                        onClick={handleOpenAddModal}
                        style={{width:'190px', height:'50px', backgroundColor:'#0065FF', textTransform:'none', borderRadius:'8px', boxShadow:'none'}}>
                        + Create New Pass
                    </Button>
                </Grid2>
            </Grid2>

            <Box sx={{ width: '100%', marginTop:'2%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <AppBar position="static" color="default" elevation={0} sx={{backgroundColor:'#2A313C', borderRadius:'12px 12px 0 0'}}>
                        <Tabs
                        value={shuttlePassTab}
                        onChange={handleAllyProps}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="booking tabs"
                        sx={{
                            '& .MuiTabs-indicator': {
                                height: '3px',
                                width: '100%'
                            }
                        }}
                        >
                        <StyledTab label={<TabWithBadge label="Shuttle Pass" count={shuttlePassData.length} isActive={shuttlePassTab === 0} />} {...a11yProps(0)} />
                        <StyledTab label={<TabWithBadge label="Shuttle Benefits" isActive={shuttlePassTab === 1} />} {...a11yProps(1)} />
                        <StyledTab label={<TabWithBadge label="How is works" isActive={shuttlePassTab === 2} />} {...a11yProps(2)} />
                        <StyledTab label={<TabWithBadge label="FAQ's" isActive={shuttlePassTab === 3} />} {...a11yProps(3)} />
                        <StyledTab label={<TabWithBadge label="Privacy Policy" isActive={shuttlePassTab === 4} />} {...a11yProps(4)} />
                        </Tabs>
                    </AppBar>
                </Box>
                
                <CustomTabPanel value={shuttlePassTab} index={0}>
                    <TableContainer className="table-container" sx={{ marginTop: '0px', maxHeight:'56vh' }}>
                        <Table stickyHeader className="scrollable-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '100px' }}>Pass ID</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '100px' }}>Pass Name</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '100px' }}>Pass Type</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '150px' }}>Morning/Evening Ride</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '120px' }}>Fare Discount</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '100px' }}>Validity</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '100px' }}>Per user cancellation limit</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '100px' }}>Total pass limit</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '100px' }}>Per user pass limit</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '150px' }}>Benefits</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '120px' }}>Status</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '120px' }}>Recommended</TableCell>
                                    <TableCell align="center" className="table-header" style={{ width: '15%', minWidth: '100px' }}>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {shuttlePassData.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={24} align="center">
                                        <Typography variant="body1">No data found</Typography>
                                    </TableCell>
                                </TableRow>
                                )}
                                {shuttlePassData.map((row) => {
                                return (
                                    <TableRow key={row.pass_id}>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pass_id}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pass_name}</Typography></TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.pass_type ==1 ? 'One Way' : 'Return'}</Typography></TableCell>
                                        <TableCell align="center">
                                            <Typography sx={{ width: 'auto', minWidth: '100px' }}>
                                                {row.morning_rides
                                                ? `${row.morning_rides} / ${row.evening_rides}`
                                                : row.total_rides}
                                            </Typography>
                                        </TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.discount_percentage}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.validity_days}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.per_user_cancellation_limit}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.total_pass_limit}</Typography></TableCell>
                                            <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.per_user_pass_limit}</Typography></TableCell>
                                        <TableCell align="center">
                                            {row.benefits ? (
                                                <ul style={{ padding: 0, margin: 0, textAlign: 'left' }}>
                                                {Array.isArray(row.benefits) ? (
                                                    row.benefits.map((benefit, i) => (
                                                    <li key={i} style={{ padding: '4px 0', borderBottom: '1px solid #eee', '&:last-child': { borderBottom: 'none' } }}>
                                                        {benefit}
                                                    </li>
                                                    ))
                                                ) : (
                                                    <span>N/A</span>
                                                )}
                                                </ul>
                                            ) : (
                                                <span>N/A</span>
                                            )}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Typography sx={{ width: '60px', minWidth: '100px', color: row.status === 0 ? '#000' : '#fff', backgroundColor: row.status==1 ? '#0DBA78' : row.status == 0 ?'#E3E5E8': '#D14545', borderRadius:'10px', fontWeight:'500' }}>
                                                {row.status==1 ? 'Active' : row.status==0 ?'Inactive' : row.status == -2? 'Expired' : 'Undefined'}
                                            </Typography>
                                        </TableCell>
                                        <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color: row.is_recommended === 1 ? '#0DBA78' : '#D14545', }}>{row.is_recommended==1 ? 'Yes' : 'No'}</Typography></TableCell>
                                        <TableCell align="center">
                                            <Grid2  sx={{display:"flex", alignItems:'center'}}>
                                                <Button
                                                    variant="contained"
                                                    onClick={() => handleDeleteShuttlePassData(row)}
                                                    sx={{
                                                        minWidth: 0, boxShadow: 'none',
                                                        padding: '6px', marginRight:'12px',
                                                        backgroundColor: '#FFF5F5',
                                                        '&:hover': {
                                                            backgroundColor: '#FFF5F5',
                                                        },
                                                    }}
                                                >
                                                    <img src={binIcon} alt="Delete" style={{ width: '16px', height: '16px' }} />
                                                </Button>
                                                {row.status != -2 && 
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => handleOpenEditShuttlePass(row)}
                                                        sx={{
                                                            minWidth: 0, boxShadow: 'none',
                                                            padding: '6px',
                                                            backgroundColor: '#F7F7F7',
                                                            '&:hover': {
                                                                backgroundColor: '#F7F7F7',
                                                            },
                                                        }}
                                                    >
                                                        <img src={blackEdit} alt="Edit" style={{ width: '16px', height: '16px' }} />
                                                    </Button>
                                                }
                                            </Grid2>
                                           
                                        </TableCell>
                                    </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTabPanel>

                <CustomTabPanel value={shuttlePassTab} index={1}>
                    <Grid2 sx={{backgroundColor:'#fff', padding:'18px', borderRadius:'8px', border:'1px solid #E3E5E8'}}>
                        <Grid2 container spacing={2}>
                            <Grid2 item>
                                <Typography sx={{fontSize:'24px', fontWeight:'500'}}>Shuttle Pass Benefits</Typography>
                                <Typography sx={{fontSize:'16px', color:'#9FA3A7'}}>Manage the benefits displayed in the mobile app</Typography>
                            </Grid2>
                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button variant="contained"
                                    onClick={handleOpenAddMetaDataModal}
                                    style={{width:'190px', height:'50px', backgroundColor:'#0065FF', textTransform:'none', borderRadius:'8px', boxShadow:'none'}}>
                                    Add Benefits
                                </Button>
                            </Grid2>
                        </Grid2>

                        {shuttlePassMetaData && shuttlePassMetaData.length > 0 ? ( 
                            shuttlePassMetaData.map((data, index) => (
                                <Grid2 container spacing={2} key={index} sx={{border:'1px solid #E3E5E8', borderRadius:'10px', padding:'8px', marginTop:'16px', display:'flex', alignItems:'center'}}>
                                    <Grid2 item size={1} sx={{textAlign:'center'}}>
                                        {data.icon_url && <img src={data.icon_url} alt="icon" width="42px" height="42px" /> }
                                    </Grid2>
                                    <Grid2 item size={9}>
                                        <Typography sx={{color:'#2A313C', fontWeight:500, fontSize:'18px'}}>
                                            {data.title}
                                        </Typography>
                                        <Typography sx={{color:'#9FA3A7', fontWeight:400, fontSize:'16px'}}>
                                            {data.description || 'No description'}
                                        </Typography>
                                    </Grid2>
                                    <Grid2 item size={2} sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', justifyContent:'center'}}>
                                        {/* <Button variant="outlined" size="small" sx={{mr: 1}} onClick={() => handleOpenEditMetaDataModal(data)}>Edit</Button> */}
                                        <Grid2>
                                            <Switch
                                            checked={data.status}
                                            onChange={(e) => changeStatusMetaData(data, e.target.checked)}
                                            />
                                        </Grid2>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditMetaDataModal(data)}
                                            sx={{
                                                minWidth: 0, boxShadow: 'none',
                                                padding: '6px',
                                                backgroundColor: '#F7F7F7',
                                                '&:hover': {
                                                    backgroundColor: '#F7F7F7',
                                                },
                                            }}
                                        >
                                            <img src={blackEdit} alt="Edit" style={{ width: '16px', height: '16px' }} />
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleDeleteMetaData(data)}
                                            sx={{
                                                minWidth: 0, boxShadow: 'none',
                                                padding: '6px', marginLeft: '8px',
                                                backgroundColor: '#FFF5F5',
                                                '&:hover': {
                                                    backgroundColor: '#FFF5F5',
                                                },
                                            }}
                                        >
                                            <img src={binIcon} alt="Delete" style={{ width: '16px', height: '16px' }} />
                                        </Button>
                                    </Grid2>
                                </Grid2>
                            )) ):
                            (
                                <Typography sx={{ 
                                    textAlign: 'center',color: '#9FA3A7',padding: '32px',border: '1px dashed #E3E5E8',
                                    borderRadius: '8px',marginTop: '16px'
                                }}>
                                    No benefits found. Click "Add Benefits" to create one.
                                </Typography>
                            )
                        }
                    </Grid2>
                </CustomTabPanel>

                <CustomTabPanel value={shuttlePassTab} index={2}>
                    <Grid2 sx={{backgroundColor:'#fff', padding:'18px', borderRadius:'8px', border:'1px solid #E3E5E8'}}>
                        <Grid2 container spacing={2}>
                            <Grid2 item>
                                <Typography sx={{fontSize:'24px', fontWeight:'500'}}>How it works</Typography>
                                <Typography sx={{fontSize:'16px', color:'#9FA3A7'}}>Manage the 'How it works' section displayed in the mobile app</Typography>
                            </Grid2>
                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button variant="contained"
                                    onClick={handleOpenAddMetaDataModal}
                                    style={{width:'190px', height:'50px', backgroundColor:'#0065FF', textTransform:'none', borderRadius:'8px', boxShadow:'none'}}>
                                    Add Step
                                </Button>
                            </Grid2>
                        </Grid2>

                        {shuttlePassMetaData && shuttlePassMetaData.length > 0 ? ( 
                            shuttlePassMetaData.map((data, index) => (
                                <Grid2 container spacing={2} key={index} sx={{border:'1px solid #E3E5E8', borderRadius:'10px', padding:'8px', marginTop:'16px', display:'flex', alignItems:'center'}}>
                                    <Grid2 item size={1} sx={{textAlign:'center'}}>
                                        {data.icon_url && <img src={data.icon_url} alt="icon" width="42" height="42" /> }
                                    </Grid2>
                                    <Grid2 item size={9}>
                                        <Typography sx={{color:'#2A313C', fontWeight:500, fontSize:'18px'}}>
                                            {data.title}
                                        </Typography>
                                        <Typography sx={{color:'#9FA3A7', fontWeight:400, fontSize:'16px'}}>
                                            {data.description || 'No description'}
                                        </Typography>
                                    </Grid2>
                                    <Grid2 item size={2} sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', justifyContent:'center'}}>
                                        <Grid2>
                                            <Switch
                                            checked={data.status}
                                            onChange={(e) => changeStatusMetaData(data, e.target.checked)}
                                            />
                                        </Grid2>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditMetaDataModal(data)}
                                            sx={{
                                                minWidth: 0, boxShadow: 'none',
                                                padding: '6px',
                                                backgroundColor: '#F7F7F7',
                                                '&:hover': {
                                                    backgroundColor: '#F7F7F7',
                                                },
                                            }}
                                        >
                                            <img src={blackEdit} alt="Edit" style={{ width: '16px', height: '16px' }} />
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleDeleteMetaData(data)}
                                            sx={{
                                                minWidth: 0, boxShadow: 'none',
                                                padding: '6px', marginLeft:'8px',
                                                backgroundColor: '#FFF5F5',
                                                '&:hover': {
                                                    backgroundColor: '#FFF5F5',
                                                },
                                            }}
                                        >
                                            <img src={binIcon} alt="Delete" style={{ width: '16px', height: '16px' }} />
                                        </Button>
                                    </Grid2>
                                </Grid2>
                            )) ):
                            (
                                <Typography sx={{ 
                                    textAlign: 'center',color: '#9FA3A7',padding: '32px',border: '1px dashed #E3E5E8',
                                    borderRadius: '8px',marginTop: '16px'
                                }}>
                                    No steps found. Click "Add Step" to create one.
                                </Typography>
                            )
                        }
                    </Grid2>
                </CustomTabPanel>

                <CustomTabPanel value={shuttlePassTab} index={3}>
                    <Grid2 sx={{backgroundColor:'#fff', padding:'18px', borderRadius:'8px', border:'1px solid #E3E5E8'}}>
                        <Grid2 container spacing={2}>
                            <Grid2 item>
                                <Typography sx={{fontSize:'24px', fontWeight:'500'}}>FAQ's</Typography>
                                <Typography sx={{fontSize:'16px', color:'#9FA3A7'}}>Manage the FAQ's displayed in the mobile app</Typography>
                            </Grid2>
                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button variant="contained"
                                    onClick={handleOpenAddMetaDataModal}
                                    style={{width:'190px', height:'50px', backgroundColor:'#0065FF', textTransform:'none', borderRadius:'8px', boxShadow:'none'}}>
                                    Add FAQ
                                </Button>
                            </Grid2>
                        </Grid2>

                        {shuttlePassMetaData && shuttlePassMetaData.length > 0 ? ( 
                            shuttlePassMetaData.map((data, index) => (
                                <Grid2 container spacing={2} key={index} sx={{border:'1px solid #E3E5E8', borderRadius:'10px', padding:'8px', marginTop:'16px', display:'flex', alignItems:'center'}}>
                                    <Grid2 item size={10}>
                                        <Typography sx={{color:'#2A313C', fontWeight:500, fontSize:'18px'}}>
                                            {data.title}
                                        </Typography>
                                        <Typography sx={{color:'#9FA3A7', fontWeight:400, fontSize:'16px'}}>
                                            {data.description || 'No description'}
                                        </Typography>
                                    </Grid2>
                                    <Grid2 item size={2} sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', justifyContent:'center'}}>
                                        <Grid2>
                                            <Switch
                                            checked={data.status}
                                            onChange={(e) => changeStatusMetaData(data, e.target.checked)}
                                            />
                                        </Grid2>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditMetaDataModal(data)}
                                            sx={{
                                                minWidth: 0, boxShadow: 'none',
                                                padding: '6px',
                                                backgroundColor: '#F7F7F7',
                                                '&:hover': {
                                                    backgroundColor: '#F7F7F7',
                                                },
                                            }}
                                        >
                                            <img src={blackEdit} alt="Edit" style={{ width: '16px', height: '16px' }} />
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleDeleteMetaData(data)}
                                            sx={{
                                                minWidth: 0, boxShadow: 'none',
                                                padding: '6px', marginLeft:'8px',
                                                backgroundColor: '#FFF5F5',
                                                '&:hover': {
                                                    backgroundColor: '#FFF5F5',
                                                },
                                            }}
                                        >
                                            <img src={binIcon} alt="Delete" style={{ width: '16px', height: '16px' }} />
                                        </Button>
                                    </Grid2>
                                </Grid2>
                            )) ):
                            (
                                <Typography sx={{ 
                                    textAlign: 'center',color: '#9FA3A7',padding: '32px',border: '1px dashed #E3E5E8',
                                    borderRadius: '8px',marginTop: '16px'
                                }}>
                                    No FAQs found. Click "Add FAQ" to create one.
                                </Typography>
                            )
                        }
                    </Grid2>
                </CustomTabPanel>

                <CustomTabPanel value={shuttlePassTab} index={4}>
                    <Grid2 sx={{backgroundColor:'#fff', padding:'18px', borderRadius:'8px', border:'1px solid #E3E5E8'}}>
                        <Grid2 container spacing={2}>
                            <Grid2 item>
                                <Typography sx={{fontSize:'24px', fontWeight:'500'}}>Privacy Policy</Typography>
                                <Typography sx={{fontSize:'16px', color:'#9FA3A7'}}>Manage the Privacy Policy section displayed in the mobile app.</Typography>
                            </Grid2>
                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button variant="contained"
                                    onClick={handleOpenAddMetaDataModal}
                                    style={{width:'190px', height:'50px', backgroundColor:'#0065FF', textTransform:'none', borderRadius:'8px', boxShadow:'none'}}>
                                    Add Policy
                                </Button>
                            </Grid2>
                        </Grid2>

                        {shuttlePassMetaData && shuttlePassMetaData.length > 0 ? ( 
                            shuttlePassMetaData.map((data, index) => (
                                <Grid2 container spacing={2} key={index} sx={{border:'1px solid #E3E5E8', borderRadius:'10px', padding:'8px', marginTop:'16px', display:'flex', alignItems:'center'}}>
                                    <Grid2 item size={10}>
                                        <Typography sx={{color:'#2A313C', fontWeight:500, fontSize:'18px'}}>
                                            {data.title}
                                        </Typography>
                                        <Typography sx={{color:'#9FA3A7', fontWeight:400, fontSize:'16px'}}>
                                            {data.description || 'No description'}
                                        </Typography>
                                    </Grid2>
                                    <Grid2 item size={2} sx={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', justifyContent:'center'}}>
                                        <Grid2>
                                            <Switch
                                            checked={data.status}
                                            onChange={(e) => changeStatusMetaData(data, e.target.checked)}
                                            />
                                        </Grid2>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleOpenEditMetaDataModal(data)}
                                            sx={{
                                                minWidth: 0, boxShadow: 'none',
                                                padding: '6px',
                                                backgroundColor: '#F7F7F7',
                                                '&:hover': {
                                                    backgroundColor: '#F7F7F7',
                                                },
                                            }}
                                        >
                                            <img src={blackEdit} alt="Edit" style={{ width: '16px', height: '16px' }} />
                                        </Button>
                                        <Button
                                            variant="contained"
                                            onClick={() => handleDeleteMetaData(data)}
                                            sx={{
                                                minWidth: 0, boxShadow: 'none',
                                                padding: '6px', marginLeft:'8px',
                                                backgroundColor: '#FFF5F5',
                                                '&:hover': {
                                                    backgroundColor: '#FFF5F5',
                                                },
                                            }}
                                        >
                                            <img src={binIcon} alt="Delete" style={{ width: '16px', height: '16px' }} />
                                        </Button>
                                    </Grid2>
                                </Grid2>
                            )) ):
                            (
                                <Typography sx={{ 
                                    textAlign: 'center',color: '#9FA3A7',padding: '32px',border: '1px dashed #E3E5E8',
                                    borderRadius: '8px',marginTop: '16px'
                                }}>
                                    No Policy found. Click "Add Policy" to create one.
                                </Typography>
                            )
                        }
                    </Grid2>
                </CustomTabPanel>
            </Box>

            {(openAddModal || editMode) && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleClose}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Grid2
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto', border: '1px solid #E3E5E8',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Grid container spacing={2}>
                                    <Typography sx={{fontWeight: '500', fontSize:'24px' }}>
                                        {editMode ? 'Edit Pass' : 'Create New Pass'}
                                    </Typography>
                                    
                                    <Grid2 sx={{marginLeft:'auto',display:'flex', alignItems:'center', border:status ? '1px solid #0DBA78' : '1px solid #C71F1F', borderRadius:'28px', padding:'2px 6px'}}>
                                        <Typography sx={{color:status ? '#0DBA78' : '#C71F1F'}}>{status ? 'Active' : 'Inactive'}</Typography>
                                        <Switch
                                            checked={status}
                                            onChange={(e) => {
                                                setPendingStatusChange(e.target.checked);
                                                if(!e.target.checked) setShowStatusConfirmModal(true);
                                                else setStatus(1);
                                            }}
                                        />
                                    </Grid2>
                                </Grid>
                               <hr style={{border: 'none', borderTop: '1px solid #E3E5E8'}} />

                                <Grid2 container spacing={2} sx={{marginTop:'24px'}}>
                                    <Grid2 item size={6}>
                                        <Label>Pass Name<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'2%'}}
                                            placeholder="Pass Name" fullWidth variant="outlined" type="text" 
                                            value={passName}
                                            onChange={(e) => setPassName(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '52px',fontSize: '16px',padding: '8px 14px', borderRadius:'8px', height:'52px'}
                                            }}
                                        />
                                    </Grid2>
                                    <Grid2 item size={6}>
                                        <Label>Pass Type<span style={{ color: 'red' }}>*</span></Label>
                                        <Select sx={{marginTop:'2%', width:'100%'}}
                                            value={passType} 
                                            fullWidth disabled={editMode}
                                            onChange={(e) => setPassType( e.target.value)}
                                            style={{ height: '52px', borderRadius: '8px',}}>
                                            <MenuItem value="">Pass Type</MenuItem>
                                            <MenuItem value="1">One Way</MenuItem>
                                            <MenuItem value="2">Return</MenuItem>
                                        </Select>
                                    </Grid2>

                                    {passType==1 && (
                                        <Grid2 item size={12}>
                                            <Label>Total Rides<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField sx={{marginTop:'1%'}}
                                                placeholder="Total rides" fullWidth variant="outlined" type="number" disabled={editMode}
                                                value={totalRides}
                                                onChange={(e) => {
                                                    const value = Math.max(0, parseInt(e.target.value));
                                                    setTotalRides(value);
                                                }}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '52px',fontSize: '16px',padding: '8px 14px', borderRadius:'8px', height:'52px'}
                                                }}
                                            />
                                        </Grid2>
                                    )}
                                    {passType==2 && (
                                        <>
                                        <Grid2 item size={4}>
                                            <Label>Morning Rides<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField sx={{marginTop:'2%'}}
                                                placeholder="Morning rides" fullWidth variant="outlined" type="number" 
                                                value={morningRides} disabled={editMode}
                                                onChange={(e) => {
                                                    const value = Math.max(0, parseInt(e.target.value));
                                                    setMorningRides(value);
                                                }}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '52px',fontSize: '16px',padding: '8px 14px', borderRadius:'8px', height:'52px'}
                                                }}
                                            />
                                        </Grid2>
                                        <Grid2 item size={4}>
                                            <Label>Evening Rides<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField sx={{marginTop:'2%'}}
                                                placeholder="Evening rides" fullWidth variant="outlined" type="number" 
                                                value={morningRides} disabled={editMode}
                                                // onChange={(e) => {
                                                //     const value = Math.max(0, parseInt(e.target.value));
                                                //     setEveningRides(value);
                                                // }}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '52px',fontSize: '16px',padding: '8px 14px', borderRadius:'8px', height:'52px'}
                                                }}
                                            />
                                        </Grid2>
                                        <Grid2 item size={4}>
                                            <Label>Total Rides<span style={{ color: 'red' }}>*</span></Label>
                                            <TextField sx={{marginTop:'2%'}}
                                                placeholder="Total rides" fullWidth variant="outlined" type="number" 
                                                value={Number(morningRides)*2} disabled={editMode}
                                                InputProps={{
                                                    inputProps: { min: 0 }, // Prevent values less than zero
                                                    style: {height: '52px',fontSize: '16px',padding: '8px 14px', borderRadius:'8px', height:'52px'}
                                                }}
                                            />
                                        </Grid2>
                                        </>
                                    )}

                                    <Grid2 item size={12}>
                                        <Label>Enter Fare Discount<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder="Fare discount" fullWidth variant="outlined" type="number" 
                                            value={totalFareDiscount} disabled={editMode}
                                            onChange={(e) => {
                                                const value = Math.max(0, parseInt(e.target.value));
                                                const val = Math.min(100, parseInt(value))
                                                setTotalFareDiscount(val);
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '52px',fontSize: '16px',padding: '8px 14px', borderRadius:'8px', height:'52px'}
                                            }}
                                        />
                                        <Grid item container sx={{backgroundColor:'#FFF1CB', marginTop:'8px', alignItems:'center', borderRadius:'8px', padding:'4px'}}>
                                            <InfoIcon sx={{color:'#2A313C', fontSize:'16px',paddingLeft:'4px'}} />
                                            <Typography sx={{ color:'#2A313C', fontSize:'14px', marginLeft:'4px'}}>You have to mention the % you want to give on pass for customer</Typography>
                                        </Grid>
                                    </Grid2>

                                    <Grid2 item size={6}>
                                        <Label>Validity<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder="30 days" fullWidth variant="outlined" type="number" 
                                            value={passType==1 ? Number(totalRides) : Number(morningRides)}
                                            // onChange={(e) => {
                                            //     const value = Math.max(0, parseInt(e.target.value));
                                            //     setValidity(value);
                                            // }} 
                                            disabled={editMode}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '52px',fontSize: '16px',padding: '8px 14px', borderRadius:'8px', height:'52px'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item size={6}>
                                        <Label>Per user ride cancellation limit</Label>
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder="" fullWidth variant="outlined" type="number" 
                                            value={perUserCancelLimit} disabled={editMode}
                                            onChange={(e) => {
                                                const value = Math.max(0, parseInt(e.target.value));
                                                setPerUserCancelLimit(value);
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '52px',fontSize: '16px',padding: '8px 14px', borderRadius:'8px', height:'52px'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item size={6}>
                                        <Label>Total pass limit</Label>
                                        <TextField sx={{marginTop:'1%'}} disabled={editMode}
                                            placeholder="" fullWidth variant="outlined" type="number" 
                                            value={passLimit}
                                            onChange={(e) => {
                                                const value = Math.max(0, parseInt(e.target.value));
                                                setPassLimit(value);
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '52px',fontSize: '16px',padding: '8px 14px', borderRadius:'8px', height:'52px'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item size={6}>
                                        <Label>Per user pass limit</Label>
                                        <TextField sx={{marginTop:'1%'}} disabled={editMode}
                                            placeholder="" fullWidth variant="outlined" type="number" 
                                            value={perUserPassLimit}
                                            onChange={(e) => {
                                                const value = Math.max(0, parseInt(e.target.value));
                                                setPerUserPassLimit(value);
                                            }}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '52px',fontSize: '16px',padding: '8px 14px', borderRadius:'8px', height:'52px'}
                                            }}
                                        />
                                    </Grid2>

                                    <Grid2 item size={12} sx={{display:'flex', alignItems:'center', marginTop:'2%'}}>
                                        <Label>Add Benefits<span style={{ color: 'red' }}>*</span></Label>
                                        <Grid item sx={{marginLeft:'auto'}}>
                                            <Button onClick={handleAddBenefit}
                                                sx={{color:'#2A313C', border:'1px solid #D1D5DB', backgroundColor:'#F9F9F9', 
                                                padding:'0px 12px', borderRadius:'8px', height:'52px', textTransform:'none'}}>
                                                Add Benefits
                                            </Button>
                                        </Grid>
                                    </Grid2>
                                    {benefits.map((benefit, index) => (
                                        <Grid2 item size={12} key={index} sx={{ display: 'flex', alignItems: 'center'}}>
                                            <Grid2 item size={11}>
                                                <TextField fullWidth variant="outlined" type="text"
                                                    value={benefit || ''}
                                                    onChange={(e) => handleBenefitChange(index, e.target.value)}
                                                    placeholder={`Benefit ${index + 1}`}
                                                    sx={{ backgroundColor:'#F7F7F7',
                                                        '& .MuiOutlinedInput-root': {
                                                            height: '52px',
                                                            '& fieldset': {borderRadius: '8px'},
                                                        },
                                                    }}
                                                />
                                            </Grid2>
                                            <Grid2 item size={1}>
                                                <IconButton 
                                                    onClick={() => handleRemoveBenefit(index)}
                                                    disabled={benefits.length <= 1}
                                                    sx={{ 
                                                        ml: 1,
                                                        color: benefits.length <= 1 ? 'rgba(0, 0, 0, 0.26)' : 'inherit'
                                                    }}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </Grid2>
                                        </Grid2>
                                    ))}
                                    
                                    <Grid2 item size={12} sx={{display:'flex', alignItems:'center', marginTop:'2%', backgroundColor:'#F7F7F7', borderRadius:'8px', padding:'4px 6px'}}>
                                        <Label>Mark as recommended</Label>
                                        <Grid item sx={{marginLeft:'auto'}}>
                                            <Switch
                                                checked={isRecommended}
                                                onChange={(e) => {
                                                    const next = e.target.checked;
                                                    const currentPassType = passType; // Make sure passType is available
                                                    
                                                    if (next) {
                                                        // Check if there's already a recommended pass of the same type
                                                        const existingOfSameType = recommendedPasses.find(
                                                            pass => pass.pass_type === currentPassType
                                                        );
                                                        
                                                        if (existingOfSameType) {
                                                            setMessage(
                                                                `A ${currentPassType === 1 ? 'One Way' : 'Return'} pass is already recommended. ` +
                                                                'Only one pass per type can be recommended.'
                                                            );
                                                            showSnackbar(true);
                                                            return;
                                                        }
                                                        
                                                        // Add to recommended passes
                                                        setRecommendedPasses(prev => [
                                                            ...prev.filter(p => p.pass_id !== passId), // Remove if exists
                                                            { pass_id: passId, pass_type: currentPassType }
                                                        ]);
                                                    } else {
                                                        // Remove from recommended passes
                                                        setRecommendedPasses(prev => prev.filter(p => p.pass_id !== passId));
                                                    }
                                                }}
                                            />
                                        </Grid>
                                    </Grid2>
                                </Grid2>

                                <div style={{ marginTop: '40px', marginBottom: '20px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleShuttlePassSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {editMode ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleClose}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Grid2>

                        </div>
                    </Box>
                </div>
            )}

            {(openAddMetaDataModal || editMetaDataMode) && (
                <div 
                    style={{position: 'fixed',top: 65, right:0, height: '100%',width: '50%',backgroundColor: '#f9f9f9',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',transition: 'right 0.3s ease-in-out',
                        zIndex: 1000,overflowY: 'auto',padding: 20
                    }}>
                    <Box>
                        <div style={{ position: 'relative', padding: '40px 0' }}>
                            <IconButton aria-label="close" onClick={handleCloseMetaDataModal}
                                style={{
                                    position: 'absolute',top: '-15px',left: '1px',color: '#333',zIndex: 10}}>
                                <CloseIcon style={{ fontSize: '32px', fontWeight: 'bold' }} />
                            </IconButton>
                            <Grid2
                                style={{ padding: '30px', maxWidth: '800px', margin: '0 auto', border: '1px solid #E3E5E8',
                                    backgroundColor: '#FFFFFF', borderRadius: '12px'}}>
                                <Grid container spacing={2}>
                                    <Typography sx={{fontWeight: '500', fontSize:'24px' }}>
                                        {getMetaTitle()}
                                    </Typography>
                                    
                                    <Grid2 sx={{marginLeft:'auto',display:'flex', alignItems:'center', border:metaDataStatus ? '1px solid #0DBA78' : '1px solid #C71F1F', borderRadius:'28px', padding:'2px 6px'}}>
                                        <Typography sx={{color:metaDataStatus ? '#0DBA78' : '#C71F1F'}}>{metaDataStatus ? 'Active' : 'Inactive'}</Typography>
                                        <Switch
                                            checked={metaDataStatus}
                                            onChange={(e) => setMetaDataStatus(e.target.checked)}
                                        />
                                    </Grid2>
                                </Grid>
                               <hr style={{border: 'none', borderTop: '1px solid #E3E5E8'}} />
                            
                                <Grid2 container spacing={2} sx={{marginTop:'24px'}}>
                                    <Grid2 item size={12}>
                                        <Label>{shuttlePassTab==3 ? 'Add Question' : 'Title'}<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder={shuttlePassTab==3 ? 'Add Question' : 'Title'} fullWidth variant="outlined" type="text" 
                                            value={metaDataTitle}
                                            onChange={(e) => setMetaDataTitle(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '52px',fontSize: '16px',padding: '8px 14px', borderRadius:'8px', height:'52px'}
                                            }}
                                        />
                                    </Grid2>
                                    <Grid2 item size={12}>
                                        <Label>{shuttlePassTab==3 ? 'Answer' : 'Description'}<span style={{ color: 'red' }}>*</span></Label>
                                        <TextField sx={{marginTop:'1%'}}
                                            placeholder={shuttlePassTab==3 ? 'Answer' : 'Description'} fullWidth variant="outlined" type="text" 
                                            value={metaDataDescription}
                                            onChange={(e) => setMetaDataDescription(e.target.value)}
                                            InputProps={{
                                                inputProps: { min: 0 }, // Prevent values less than zero
                                                style: {height: '52px',fontSize: '16px',padding: '8px 14px', borderRadius:'8px', height:'52px'}
                                            }}
                                        />
                                    </Grid2>
                                    {(shuttlePassTab==1 || shuttlePassTab==2) && (
                                        <Grid2 item size={12}>
                                            <Label>Add Icon<span style={{ color: 'red' }}>*</span></Label>
                                            <br/>
                                            <input type="file" accept="image/*" onChange={handleFileChange} style={{ marginTop: '8px' }} />
                                            <br/>
                                            {metaDataIcon ? 
                                                <img src={metaDataIcon} alt="metadata icon" style={{marginTop:'8px', width:'64px', height:'64px'}} />
                                            : null}

                                            <Grid item container sx={{backgroundColor:'#FFF1CB', marginTop:'8px', alignItems:'center', borderRadius:'8px', padding:'4px'}}>
                                                <InfoIcon sx={{color:'#2A313C', fontSize:'16px',paddingLeft:'4px'}} />
                                                <Typography sx={{ color:'#2A313C', fontSize:'14px', marginLeft:'4px'}}>Upload a custom icon to override the default icon. Recommended size: 64x64px</Typography>
                                            </Grid>
                                        </Grid2>
                                    )}
                                    
                                </Grid2>
                                <div style={{ marginTop: '40px', marginBottom: '20px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleShuttlePassMetaDataSubmit}
                                        sx={{width: '140px',height: '50px',textTransform: 'none',
                                            fontSize: '16px',backgroundColor: '#0065FF',color: 'white'}}>
                                        {editMode ? 'Update' : 'Save'}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={handleCloseMetaDataModal}
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            textTransform: 'none',
                                            fontSize: '16px',
                                            backgroundColor: '#F0F0F0',
                                            color: '#B0B0B0',
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </div>
                            </Grid2>
                        </div>
                    </Box>
                </div>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
            
            {/* Status Change Confirmation Modal */}
            <Modal
                open={showStatusConfirmModal}
                onClose={() => setShowStatusConfirmModal(false)}
                aria-labelledby="status-confirm-modal"
                aria-describedby="status-confirm-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: '#fff',
                    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
                    borderRadius: '12px',
                    outline: 'none'
                }}>
                    {/* Header */}
                    <Box sx={{ 
                        p: '20px 24px',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.08)'
                    }}>
                        <Typography 
                            id="status-confirm-modal" 
                            variant="h6" 
                            component="h2" 
                            sx={{
                                color: '#D9534F',
                                fontWeight: 600,
                                m: 0,
                                lineHeight: 1.5
                            }}
                        >
                            Warning
                        </Typography>
                    </Box>
                    
                    {/* Content */}
                    <Box sx={{ 
                        p: '24px',
                        '& > * + *': {
                            mt: '20px'  // Adds margin between direct children
                        }
                    }}>
                        <Typography 
                            id="status-confirm-description" 
                            sx={{ 
                                color: '#4A5568',
                                lineHeight: 1.6,
                                m: 0
                            }}
                        >
                            This will remove the pass from all attached routes immediately and can't be undone.
                        </Typography>
                        
                        {/* Buttons */}
                        <Box sx={{ 
                            display: 'flex', 
                            justifyContent: 'flex-end', 
                            gap: '12px',
                            pt: '8px'
                        }}>
                            <Button 
                                variant="outlined" 
                                onClick={() => setShowStatusConfirmModal(false)}
                                sx={{ 
                                    textTransform: 'none',
                                    px: 3,
                                    py: '6px',
                                    borderColor: '#E2E8F0',
                                    color: '#4A5568',
                                    '&:hover': {
                                        borderColor: '#CBD5E0',
                                        bgcolor: '#F8FAFC'
                                    }
                                }}
                            >
                                Cancel
                            </Button>
                            <Button 
                                variant="contained" 
                                onClick={() => {
                                    setStatus(pendingStatusChange);
                                    setShowStatusConfirmModal(false);
                                }}
                                sx={{ 
                                    textTransform: 'none',
                                    px: 3,
                                    py: '6px',
                                    bgcolor: '#D9534F',
                                    '&:hover': {
                                        bgcolor: '#C12E2A'
                                    }
                                }}
                            >
                                Confirm
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
            
        </div>
    )
}

export default ShuttlePass;